export const replaceUnderscoreWithSpace = (str: string) => {
  return str.replace(/_/g, ' ');
};
